import styled from 'styled-components';

export const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 20px;
  padding: 10px;
  background: #f7f7f7;
  border-radius: 8px;
`;

export const FilterSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FilterLabel = styled.label`
  font-weight: bold;
  margin-bottom: 4px;
`;

export const FilterSelect = styled.select`
  padding: 6px;
  min-width: 120px;
`;

export const FilterCheckbox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FilterDateInput = styled.input`
  padding: 6px;
  min-width: 140px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const FilterDateRange = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;